import { render, staticRenderFns } from "./GalleryEmptyLink.vue?vue&type=template&id=09ffcb8f&scoped=true&"
import script from "./GalleryEmptyLink.vue?vue&type=script&lang=js&"
export * from "./GalleryEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ffcb8f",
  null
  
)

export default component.exports